<template>
    <v-popover offset="0" :open="isOpen" trigger="click" :autoHide="true" v-on:auto-hide="close">

        <span class="tooltip-target" @click="open" data-testid="client-banner-gdpr">
          <template v-if="client.gdpr_consent">
            <span class="badge badge-success" data-testid="client-gdpr-badge-agreed" v-if="client.gdpr_consent.agreed" v-tooltip="{
                        content: 'souhlasil dne: <b>' + client.gdpr_consent.recorded_on + '</b>',
                        placement: 'bottom-center',
                        classes: ['info']}">
                GDPR
              <i class="fa fa-check text-white" aria-hidden="true"></i>
            </span>
            <span class="badge badge-secondary" data-testid="client-gdpr-badge-disagreed" v-else v-tooltip="{
                        content: 'NEsouhlasil dne: <b>' + client.gdpr_consent.recorded_on + '</b>',
                        placement: 'bottom-center',
                        classes: ['secondary']}">
                GDPR
              <i class="fa fa-times text-white" aria-hidden="true"></i>
            </span>
          </template>
          <span class="badge badge-danger" data-testid="client-gdpr-badge-missing" v-else v-tooltip="{
                        content: 'nemá vyplněné GDPR',
                        placement: 'bottom-center',
                        classes: ['danger']}">
                bez GDPR
              <i class="fa fa-exclamation-triangle text-white" aria-hidden="true"></i>
          </span>
        </span>
        <template slot="popover">
            <div class="container tooltip_container tooltip_1_5_col">
                <div class="row tooltip_header">
                    <div class="col-sm-2 text-left">
                      <div class="col-sm-2 text-right">
                        <a class="btn btn-sm btn-outline-secondary" target="_blank" :href="setting.hostname + 'client/' + client.id + '/gdpr/pdf'">Formulář</a>
                      </div>
                    </div>
                    <div class="col-sm-8">GDPR souhlas klienta</div>
                    <div class="col-sm-2 text-right">
                        <button class="btn btn-sm btn-outline-secondary" @click="close"><i class="fa fa-times" aria-hidden="true"></i></button>
                    </div>
                </div>

                <div class="row" v-if="client.gdpr_consent">
                    <table class="table">
                        <thead>
                        <tr class="row m-0">
                            <th class="col-sm-7">souhlasí s GDPR</th>
                            <th class="col-sm-3">datum (ne)souhlasu</th>
                            <th class="col-sm-2"> </th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr class="row m-0 text-left" data-testid="client-gdpr-row">
                                <td class="col-sm-7">{{ client.gdpr_consent.agreed | boolToCS }}</td>
                                <td class="col-sm-3">{{ client.gdpr_consent.recorded_on }}</td>
                                <td class="text-right col-sm-2">
                                    <button class="btn btn-sm btn-danger" data-testid="client-gdpr-delete" @click="deleteGdprConsent(client.gdpr_consent.id)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row" v-if="!client.gdpr_consent">
                    <div class="form-group col-md-12">
                        <form @submit.prevent="submitFormAddGdprConsent">
                            <div class="input-group">
                              <div class="">
                                <span>Datum (ne)souhlasu:</span>
                                <datepicker v-model="selectedDate" placeholder="vybrat datum (ne)souhlasu" format="dd.MM.yyyy" language="cs" :monday-first="true" :full-month-name="true" name="chooseDate" input-class="datapickerInput" v-on:input="manualSelectDate($event)"></datepicker>
                              </div>
                                <span class="input-group-addon">
                          Souhlasil:&nbsp;
                        <input v-model="newGdprConsent.agreed" type="checkbox" data-testid="client-gdpr-agreed">
                      </span>
                                <button v-if="newGdprConsentPending === false" type="submit" class="btn btn-primary" data-testid="client-gdpr-submit">Přidat</button>
                                <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                            </div>
                            <small id="numberError" class="form-text text-danger text-left" v-if="newGdprConsentError.number">{{ newGdprConsentError.number.message }}</small>
                        </form>
                    </div>
                </div>
            </div>
        </template>
    </v-popover>
</template>

<script>
  import apiMixin from '@/mixins'
  import moment from 'moment'

  export default {
    data () {
      return {
        editMode: false,
        isOpen: false,
        newGdprConsent: {
          agreed: true,
          recorded_on: ''
        },
        setting: require('@/variables.js'),
        selectedDate: '',
        newGdprConsentError: false,
        newGdprConsentPending: false,
        newGdprConsentDone: false,
        updatedGdprConsent: {},
        updatedGdprConsentError: false,
        updatedGdprConsentPending: false,
        updatedGdprConsentDone: false,
        deleteGdprConsentError: false,
        deleteGdprConsentPending: false,
        deleteGdprConsentDone: false,
        editingId: false
      }
    },
    mixins: [apiMixin],
    props: ['client', 'clientHeader'],
    methods: {
      init () {
        this.newGdprConsent = {agreed: true}
        this.selectedDate = moment().toDate()
        this.newGdprConsentError = false
        this.editingId = false
        this.updatedGdprConsent = {}
        this.updatedGdprConsentError = false
        this.updatedGdprConsentPending = false
        this.updatedGdprConsentDone = false
        this.deleteGdprConsentError = false
        this.deleteGdprConsentPending = false
        this.deleteGdprConsentDone = false
      },
      open () {
        this.init()
        this.isOpen = true
      },
      close () {
        this.isOpen = false
      },
      edit () {
        this.editMode = true
      },
      view () {
        this.editMode = false
      },
      submitFormAddGdprConsent () {
        // console.log(this.newGdprConsent)
        this.newGdprConsentError = false
        this.postGdprConsent(this.newGdprConsent, this.client.id)
      },
      submitFormUpdateGdprConsent () {
        // console.log(this.updatedGdprConsent)
        this.updatedGdprConsentError = false
        this.putGdprConsent(this.updatedGdprConsent)
      },
      setEditingGdprConsent (gdprConsent) {
        if (this.editingId === false) {
          this.updatedGdprConsent = JSON.parse(JSON.stringify(gdprConsent))
          this.editingId = gdprConsent.id
        } else {
          this.updatedGdprConsent = {}
          this.editingId = false
        }
      }
    },
    watch: {
      isOpen (val) {
        if (val === true) {
          //
        } else {
          //
        }
      },
      selectedDate: function (val) {
        this.newGdprConsent.recorded_on = moment(val).format('DD.MM.YYYY')
      },
      newGdprConsentDone (val) {
        this.newGdprConsent = {agreed: true}
        if (val === true) {
          this.$emit('reload-client', true)
          this.$emit('reload-client', false)
          this.newGdprConsentDone = false
          // this.close()
        }
      },
      deleteGdprConsentDone (val) {
        if (val === true) {
          this.$emit('reload-client', true)
          this.$emit('reload-client', false)
          this.deleteGdprConsentDone = false
          // this.close()
        }
      },
      updatedGdprConsentDone (val) {
        if (val === true) {
          this.editingId = false
          this.updatedGdprConsent = {}
          this.$emit('reload-client', true)
          this.$emit('reload-client', false)
          this.updatedGdprConsentDone = false
          // this.close()
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .badge_large {
        font-size: xx-large;
    }
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .input-group.input-group-unstyled input.form-control {
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
    }
    .input-group-unstyled .input-group-addon {
        border-radius: 4px;
        border: 0px;
        background-color: transparent;
    }
    .row_description {
    }
    .row_description > td {
        padding-bottom: 1px;
        border: none;
        font-size: smaller;
    }
    .row_data {
    }
    .row_data > td {
        padding-top: 0px;
        font-weight: bold;
        font-size: large;
        border: none;
    }

    .width_fix {
        width: 100%;
    }
    .label_like {
        max-width: 100%;
        /*font-weight: bold;*/
    }
    .main_attribute {
        max-width: 100%;
        font-size: x-large;
        font-weight: bold;
    }

    .custom_panel_heading {
        border-bottom: none;
        padding-bottom: 0;
        background-color: #b5e3cf;
    }

    .custom_panel_heading .nav-tabs {
        border-bottom: none;
    }

    .custom_panel_heading .nav-tabs > li > a {
        background-color: #fff;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(odd) {
        margin-right: 0;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(even) {
        margin-left: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/Client/components/ClientGdprConsent.vue?6ca2bc33